<div id="mainContent" class="container">
  <div class="modal-body" *ngIf="folderList != undefined">
    <div class="row">
      <div class="col-sm-6" style="cursor: pointer; color: #800000; font-size: 16px" *ngIf="hidePermission"
        [ngClass]="{'disabled': folderList.mis}"
        [ngStyle]="{'opacity': folderList.mis ? '0.5' : '1', 'cursor': folderList.mis ? 'not-allowed' : 'pointer'}"
        (click)="folderList.mis ? null : onModalClick(documentModalContent)">
        <i class="fa fa-plus-square-o" aria-hidden="true"></i>
        <span class="ml-2">Add Document</span>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-sm-6">
        <label style="font-size: 16px">Folder Name : <span>{{ folderList.name }}</span></label>
      </div>
      <!-- <div class="col-sm-1">
        <a style="color: #800000; font-size: 16px; cursor: pointer">Add</a>
      </div> -->
      <div class="col-sm-2" *ngIf="hidePermission"
        style="cursor: pointer; color: #800000!important; text-decoration: underline"
        [ngClass]="{'disabled': folderList.mis}"
        [ngStyle]="{'opacity': folderList.mis ? '0.5' : '1', 'cursor': folderList.mis ? 'not-allowed' : 'pointer'}">
        <a (click)="folderList.mis ? null : onAddFolderClick(folderModalContent)"><i class="fa fa-plus"></i> Add Folder
        </a>
      </div>
      <div class="col-sm-2" *ngIf="hidePermission"
        style="cursor: pointer; color: #800000!important; text-decoration: underline"
        [ngClass]="{'disabled': folderList.mis}"
        [ngStyle]="{'opacity': folderList.mis ? '0.5' : '1', 'cursor': folderList.mis ? 'not-allowed' : 'pointer'}">
        <a (click)="folderList.mis ? null : onEditFolderClick()"><i class="fa fa-edit"></i> Edit Folder
        </a>
      </div>
      <div class="col-sm-2" *ngIf="hidePermission"
        style="cursor: pointer; color: #800000!important; text-decoration: underline"
        [ngClass]="{'disabled': folderList.mis}"
        [ngStyle]="{'opacity': folderList.mis ? '0.5' : '1', 'cursor': folderList.mis ? 'not-allowed' : 'pointer'}">
        <a (click)="folderList.mis ? null : onDeleteFolderClick()"><i class="fa fa-trash"></i> Delete Folder
        </a>
      </div>
    </div>

    <div class="row mt-1" *ngIf="
        folderList.subFolder.length > 0 || mainFolderDocumentsList.length > 0
      ">
      <div class="table-responsive">
        <table class="table table-bordered table-striped table-borderless">
          <thead>
            <tr>
              <th width="5%">Type</th>
              <th width="35%">Name</th>
              <th width="30%">Updated Date</th>
              <th width="10%"></th>
              <th width="10%"></th>
            </tr>
          </thead>
          <ng-container>
            <tbody *ngFor="let subfolder of folderList.subFolder; let i = index">
              <td width="5%" style="color: #800000!important">
                <i class="fa fa-folder fa-lg"></i>
              </td>
              <td width="35%" (click)="folderDetails(subfolder)">
                <span style="color: #800000!important; cursor: pointer">{{
                  subfolder.name
                  }}</span>
              </td>
              <td width="30%">
                {{ folderList.updatedDate | date: "dd-MMMM-yyyy" }}
              </td>
              <td width="10%"></td>
              <td width="10%"></td>
            </tbody>
          </ng-container>
          <ng-container>
            <tbody *ngFor="let document of mainFolderDocumentsList; let i = index">
              <td width="5%" *ngIf="!document.url; else elseBlock">
                <i class="fa fa-file"></i>
              </td>
              <ng-template #elseBlock>
                <td style="color: #800000!important">
                  <i width="5%" class="fa fa-link" aria-hidden="true"></i>
                </td>
              </ng-template>

              <td style="color: #800000!important" *ngIf="!document.url; else elseBlock1" width="35%">
                {{ document.name }}
              </td>
              <ng-template #elseBlock1>
                <td width="35%">
                  <a style="color: #800000!important" href="{{ document.s3location }}" target="_blank"
                    rel="noopener noreferrer">{{ document.name }}</a>
                </td>
              </ng-template>

              <td *ngIf="!document.url; else elseBlock2" width="30%">
                {{ document.updatedDate | date: "dd-MMMM-yyyy" }}
              </td>
              <ng-template #elseBlock2>
                <td width="30%"></td>
              </ng-template>

              <td *ngIf="!document.url; else elseBlock3" width="10%">
                <div *ngIf="!document.viewOnly;else elseBlockDocument">
                  <a style="color: #800000!important" href="{{ document.s3location }}" target="_blank"
                    rel="noopener noreferrer"><i class="fa fa-download fa-lg"></i></a>
                </div>
                <ng-template #elseBlockDocument>
                  <a style="color: #800000!important"
                    (click)="onViewDocumentModalClick(viewDocumentContent,document)"><i class="fa fa-eye fa-lg"></i></a>
                </ng-template>
              </td>
              <ng-template #elseBlock3>
                <td width="10%"></td>
              </ng-template>

              <td width="10%" *ngIf="hidePermission">
                <i *ngIf="!document.url" [ngClass]="{'disabled': folderList.mis}"
                  [ngStyle]="{'opacity': folderList.mis ? '0.5' : '1', 'cursor': folderList.mis ? 'not-allowed' : 'pointer'}"
                  (click)="folderList.mis ? null : onEditDocument(document, documentModalContent)"
                  class="fa fa-edit fa-lg" aria-hidden="true"></i>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <i *ngIf="!document.url; else elseBlock4" [ngClass]="{'disabled': folderList.mis}"
                  [ngStyle]="{'opacity': folderList.mis ? '0.5' : '1', 'cursor': folderList.mis ? 'not-allowed' : 'pointer'}"
                  (click)="folderList.mis ? null : onDeleteDocument(document)" class="fa fa-trash fa-lg"
                  aria-hidden="true"></i>
                <ng-template #elseBlock4>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <i [ngClass]="{'disabled': folderList.mis}"
                    [ngStyle]="{'opacity': folderList.mis ? '0.5' : '1', 'cursor': folderList.mis ? 'not-allowed' : 'pointer'}"
                    (click)="folderList.mis ? null : onDeleteDocument(document)" class="fa fa-trash fa-lg"
                    aria-hidden="true"></i>
                </ng-template>
              </td>
            </tbody>
          </ng-container>
        </table>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showOpenModal">
  <app-create-folder [folderDetail]="folderList" [hideSaveButtonOnEdit]="hideSaveButton"
    (modalChanged)="modalChangeValue($event)"></app-create-folder>
</div>

<ng-template #documentModalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">Upload Document</h5>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button> -->
  </div>
  <div class="modal-body">
    <div class="row mt-3" *ngIf="!showInputForUrl">
      <div class="col-sm-3">
        <label>Select Document:</label>
      </div>
      <div class="col-sm-5">
        <input #file type="file"
          accept="image/*,.doc, .docx,.ppt,.pptx,.txt,.pdf,.xlsx,.rtf,.xls,video/mp4,video/x-m4v,video/*,audio/mp3,audio/ogg,audio/mp4"
          placeholder="Upload file" (change)="fileChange($event)" />
      </div>
      <div class="col-sm-4">
        <a href="{{ editDocumnetURL }}" target="_blank" rel="noopener noreferrer">
          <!-- <i class="fa fa-download fa-3x" aria-hidden="true"></i>
          <br /> -->
          <span>{{ editDocumentName }}</span>
        </a>
      </div>
    </div>

    <div class="row mt-3" *ngIf="!showInputForUrl">
      <div class="col-sm-3">
        <label>View Only:</label>
      </div>
      <div class="col-sm-1">
        <input type="checkbox" id="downloadecheckbox" name="downloadecheckbox" [(ngModel)]="isDownloadCheck"
          (change)="downloadCheckBoxClick($event)" />
      </div>

    </div>

    <div class="row mt-3" *ngIf="hideCheckboxOnEdit">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-1">
            <input type="checkbox" id="check" name="check" (change)="clickCheckBox($event)" />
          </div>
          <div class="col-sm-11">
            <span *ngIf="!showInputForUrl">Click here to add url</span>
            <span *ngIf="showInputForUrl">Uncheck to attach document</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4" *ngIf="showInputForUrl">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-3">
            <label for="">Enter Name<span class="text-danger">*</span> :</label>
          </div>
          <div class="col-sm-7">
            <input type="text" id="urlName" name="urlName" class="form-control" [(ngModel)]="documentUrlName" />
          </div>
        </div>
      </div>
      <div class="col-sm-12 mt-2">
        <div class="row">
          <div class="col-sm-3">
            <label for="">Enter URL<span class="text-danger">*</span> :</label>
          </div>
          <div class="col-sm-7">
            <input type="text" id="enterURL" name="enterURL" class="form-control" [(ngModel)]="documentUrl" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <button id="" name="" type="button" class="btn btn-sm btn-block btn-outline-theme"
          *ngIf="!hideSaveDocumentButton" (click)="onSaveButtonClick()">
          Save
        </button>

        <button id="updateAnnouncementDetail" name="updateAnnouncementDetailBtn" type="button"
          class="btn btn-sm btn-block btn-outline-theme" *ngIf="hideSaveDocumentButton" (click)="onUpdateDocument()">
          Update
        </button>
      </div>

      <div class="col-sm-3">
        <button id="" name="" type="button" class="btn btn-sm btn-block btn-outline-secondary" ngbAutofocus
          (click)="closeModel()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #folderModalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">Add Folder</h5>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-2">
        <label for="folderName" class="col-form-label">Folder Name </label>
      </div>
      <div class="col-sm-5">
        <input type="text" class="form-control" required name="folderName" [(ngModel)]="documentModel.name" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-sm-2">
        <label class="col-form-label">Role</label>
      </div>
      <div class="col-sm-5">
        <select class="form-control form-control-xs mt-1" name="roleName" [(ngModel)]="selectedRole"
          (change)="onRoleChange()">
          <option [ngValue]="null">Select Role</option>
          <option *ngFor="let role of roleList" [ngValue]="role">
            {{ role.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-sm-2">
        <label class="col-form-label">Service Vertical</label>
      </div>
      <div class="col-sm-5">
        <select class="form-control form-control-xs mt-1" name="serviceVertical" [(ngModel)]="selectedServiceVertical"
          (change)="onServiceVerticalChange()" [disabled]="!selectedRole || selectedRole?.name === 'Article'">
          <option [ngValue]="null">Select Service Vertical</option>
          <option *ngFor="let serviceVertical of serviceVerticalList" [ngValue]="serviceVertical">
            {{ serviceVertical.name }}
          </option>
        </select>
      </div>
    </div>
    <div>
      <table class="table table-striped table-bordered mt-4" *ngIf="documentModel.access.length > 0">
        <thead>
          <th>Role</th>
          <th>Service Vertical</th>
          <th>Read</th>
          <th>Write</th>
          <th></th>
        </thead>
        <tbody *ngFor="let role of documentModel.access; let i = index">
          <td>{{ role.role.name }}</td>
          <td *ngIf="role.serviceVertical">{{ role.serviceVertical.name }}</td>
          <td *ngIf="!role.serviceVertical">-</td>
          <td>
            <input type="checkbox" disabled [(ngModel)]="role.readAccess" />
          </td>
          <td>
            <input type="checkbox" [(ngModel)]="role.writeAccess" />
          </td>
          <td (click)="deleteRoleRow(i)">
            <i class="fa fa-remove fa-2x" style="color: red; cursor: pointer"></i>
          </td>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>

      <div class="col-sm-3">
        <button id="updatePersonalDetailsBtn" name="updatePersonalDetailsBtn" type="button"
          class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveFolderClick()">
          Save
        </button>
      </div>

      <div class="col-sm-3">
        <button id="closePersonalDetailsBtn" name="closePersonalDetailsBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" ngbAutofocus (click)="closeModel()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>





<ng-template #viewDocumentContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">View Document</h5>
  </div>
  <div class="modal-body">
    <!-- <embed src="viewDocumentUrl" width="100%" height="100%" /> -->
    <iframe [src]="viewDocumentUrl |unsafeDocument" id="showURL" width="100%" height="450"></iframe>
    <!-- <object type="application/pdf" data="viewDocument.s3location#toolbar=0" style="width:100%;height:600px"></object> -->
  </div>

  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
      </div>

      <div class="col-sm-3">
        <button id="" name="" type="button" class="btn btn-sm btn-block btn-outline-secondary" ngbAutofocus
          (click)="closeModel()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>